export default {
  momentLocale: 'ms-my',
  Timeline: {
    expand: 'Kembangkan',
    fold: 'Tutup',
  },
  Balloon: {
    close: 'Tutup',
    confirm: 'Setuju',
    cancel: 'Batal',
  },
  Card: {
    expand: 'Kembangkan',
    fold: 'Tutup',
  },
  Calendar: {
    today: 'Hari ini',
    now: 'Saat ini',
    ok: 'Sahkan',
    clear: 'Kosongkan',
    month: 'Bulan',
    year: 'tahun',
    prevYear: 'Tahun lepas',
    nextYear: 'setahun depan',
    prevMonth: 'Bulan Lalu',
    nextMonth: 'Bulan depan',
    prevDecade: 'Tahun Sebelumnya 12',
    nextDecade: 'Setahun dua belas kemudian',
    yearSelectAriaLabel: 'Pilih Tahun',
    monthSelectAriaLabel: 'Pilih Bulan',
    format: {
      months: '1 Bulan_2 Bulan_3 Bulan_4 Bulan_5 Bulan_6 Bulan_7 Bulan_8 Bulan_9 Bulan_10 Bulan_11 Bulan_12 Bulan'.split(
        '_',
      ),
      shortMonths: '1 Bulan_2 Bulan_3 Bulan_4 Bulan_5 Bulan_6 Bulan_7 Bulan_8 Bulan_9 Bulan_10 Bulan_11 Bulan_12 Bulan'.split(
        '_',
      ),
      weekdays: 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
      shortWeekdays: 'Aha_Isn_Sel_Rab_Kham_Jum_Sab'.split('_'),
      veryShortWeekdays: 'Aha_Isn_Sel_Rab_Kham_Jum_Sab'.split('_'),
      yearLabel: 'YYYY',
    },
  },
  DatePicker: {
    placeholder: 'Sila pilih tarikh',
    datetimePlaceholder: 'Sila pilih tarikh dan masa',
    monthPlaceholder: 'Sila pilih bulan',
    yearPlaceholder: 'Sila pilih tahun',
    now: 'Saat ini',
    selectTime: 'Pilih Masa',
    selectDate: 'Pilih tarikh',
    ok: 'Sahkan',
    clear: 'Kosongkan',
    startPlaceholder: 'Tarikh mulakan',
    endPlaceholder: 'Tarikh Tamat',
    hour: 'Masa',
    minute: 'minit',
    second: 'saat',
  },
  Dialog: {
    close: 'Tutup',
    ok: 'Sahkan',
    cancel: 'Batal',
  },
  Message: {
    closeAriaLabel: 'Tutup',
  },
  Pagination: {
    goTo: 'Pergi ke',
    page: 'Halaman',
    total: 'Halaman {current} daripada {total}',
    labelPrev: 'Halaman sebelumnya, halaman semasa {current}',
    labelNext: 'Halaman seterusnya, halaman semasa {current}',
    inputAriaLabel: 'Sila masukkan bilangan halaman yang ingin anda ke',
    selectAriaLabel: 'Sila pilih berapa entri untuk ditunjukkan setiap halaman',
    pageSize: 'Item/Halaman',
  },
  Input: {
    clear: 'Kosongkan',
  },
  Select: {
    selectPlaceholder: 'Sila pilih',
    autoCompletePlaceholder: 'Sila masukkan',
    notFoundContent: 'Tiada pilihan',
    maxTagPlaceholder: '{selected}/{total} item dipilih',
  },
  Table: {
    empty: 'Tiada data',
    ok: 'Sahkan',
    reset: 'Set Semula',
    asc: 'Menaik',
    desc: 'Menurun',
    expanded: 'Dibuka',
    folded: 'Dibungkuk',
    filter: 'Saring',
    selectAll: 'Pilih Semua',
  },
  TimePicker: {
    placeholder: 'Sila pilih masa',
    startPlaceholder: 'Masa Mulai',
    endPlaceholder: 'Masa tamat',
    clear: 'Kosongkan',
    hour: 'masa',
    minute: 'min',
    second: 'saat',
  },
  Transfer: {
    items: 'item',
    item: 'item',
    moveAll: 'Pindah Semua',
    searchPlaceholder: 'Sila masukkan',
    moveToLeft: 'Batalkan pemilihan elemen',
    moveToRight: 'Hantar elemen yang dipilih',
  },
  Upload: {
    card: {
      cancel: 'Batal',
      addPhoto: 'Muat naik gambar',
      download: 'Muat turun',
      delete: 'Padam',
    },
    drag: {
      text: 'Klik atau seret fail ke dalam kotak garis-garis untuk muat naik',
      hint: 'Mendukung jenis fail termasuk docx, xls, PDF, rar, zip, PNG, JPG, dan lain-lain',
    },
    upload: {
      delete: 'Padam',
    },
  },
  Search: {
    buttonText: 'Cari',
  },
  Tag: {
    delete: 'Padam',
  },
  Rating: {
    description: 'Pilihan Penilaian',
  },
};
